import { getMarkets } from '@app/ducks';
import { isEmpty } from '@app/utils/isEmpty';
import { identity, sortBy } from 'ramda';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface Props {
  markets: string[];
}

export const MenuItemMarkets = ({ markets }: Props) => {
  const { t } = useTranslation(['cms', 'common', 'menu']);
  const allMarkets = useSelector(getMarkets);

  if (isEmpty(markets)) {
    return <div className="text-neutral-40 body-5">{t('menu:no_markets_assigned')}</div>;
  }

  return (
    <div className="line-clamp-2 text-neutral-40 body-5">
      {t('cms:market_other')}: {markets.length === allMarkets.length ? t('common:all') : sortBy(identity, markets).join(', ')}
    </div>
  );
};
